import { IProductHistoryEvent } from "@/common/types";
import { ChangesWrapper, TimelineItem } from "../style";
import { eventColorKey, formatChangeValue, formatEventDate } from "../format";

export interface IHistoryEventProps {
  event: IProductHistoryEvent;
}

/** One immutable lifecycle event in the approval-history timeline. */
export function HistoryEvent({ event }: IHistoryEventProps) {
  const actorName = event.actor?.name || "System";
  const actorRole = event.actor?.role;
  const changedFields = event.changed_fields ?? [];

  return (
    <TimelineItem colorKey={eventColorKey(event.event_type)}>
      <div className="track">
        <div className="dot" />
        <div className="line" />
      </div>

      <div className="event">
        <div className="event-head">
          <h4 className="event-label">{event.label}</h4>
          <span className="event-date">{formatEventDate(event.occurred_at)}</span>
        </div>

        <span className="event-actor">
          by {actorName}
          {actorRole ? ` · ${actorRole}` : ""}
        </span>

        {event.remark ? (
          <p className="event-remark">
            <span className="remark-label">Remark: </span>
            {event.remark}
          </p>
        ) : null}

        {changedFields.length > 0 ? (
          <ChangesWrapper>
            <span className="changes-title">
              {changedFields.length} field
              {changedFields.length === 1 ? "" : "s"} changed
            </span>
            {changedFields.map((change) => (
              <div className="change-row" key={change.field}>
                <span className="change-field">{change.label}</span>
                <span className="change-from">
                  {formatChangeValue(change.from)}
                </span>
                <span className="change-arrow">&rarr;</span>
                <span className="change-to">{formatChangeValue(change.to)}</span>
              </div>
            ))}
          </ChangesWrapper>
        ) : null}

        {/* A backfilled row was reconstructed from the product's current state
            by the MED-653 migration, not observed as it happened. */}
        {event.metadata?.backfilled ? (
          <span className="event-note">
            Reconstructed from existing records — predates history tracking.
          </span>
        ) : null}
      </div>
    </TimelineItem>
  );
}
